import { addAlert } from './alerts';
import { postPrompt, prompt } from './prompts';
import { sendPostRequest } from './utils';

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = () =>
            reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(script);
    });
}

let browserPrintLoadPromise = null;

function loadBrowserPrintSDK(src) {
    if (typeof BrowserPrint !== 'undefined') return Promise.resolve();
    if (!browserPrintLoadPromise) {
        browserPrintLoadPromise = loadScript(src).catch((err) => {
            browserPrintLoadPromise = null;
            throw err;
        });
    }
    return browserPrintLoadPromise;
}

export async function printLabel(
    barcodeValue,
    { method, printUrl, zplUrl, sdkUrl, skipConfirm = false },
) {
    if (method === 'browser_print') {
        if (!skipConfirm) {
            const confirmation = await prompt({
                title: gettext('Duplikacja ID'),
                text: gettext(
                    'Czy na pewno chcesz wydrukować duplikat etykiety?',
                ),
            });
            if (!confirmation.isConfirmed) return;
        }

        try {
            await loadBrowserPrintSDK(sdkUrl);
        } catch {
            addAlert(
                'error',
                gettext('Nie udało się załadować SDK Browser Print'),
            );
            return;
        }

        let zpl;
        try {
            const resp = await fetch(
                `${zplUrl}?barcode_value=${encodeURIComponent(barcodeValue)}`,
            );
            if (!resp.ok) {
                const err = await resp.json();
                addAlert(
                    'error',
                    err.message || gettext('Błąd pobierania ZPL'),
                );
                return;
            }
            ({ zpl } = await resp.json());
        } catch {
            addAlert('error', gettext('Nie udało się pobrać ZPL z serwera'));
            return;
        }

        BrowserPrint.getDefaultDevice(
            'printer',
            (device) => {
                if (!device) {
                    addAlert(
                        'error',
                        gettext('Browser Print: brak domyślnej drukarki'),
                    );
                    return;
                }
                device.send(
                    zpl,
                    () =>
                        addAlert(
                            'success',
                            gettext('Wydrukowano przez Browser Print'),
                        ),
                    (err) => addAlert('error', `Browser Print: ${err}`),
                );
            },
            (err) => {
                addAlert(
                    'error',
                    `${gettext('Browser Print agent niedostępny')}: ${err}`,
                );
            },
        );
    } else {
        if (skipConfirm) {
            try {
                const response = await sendPostRequest(printUrl, {
                    barcode_value: barcodeValue,
                });
                const data = await response.json();
                addAlert('success', data.message);
            } catch (error) {
                addAlert(
                    'error',
                    error.data?.message ||
                        gettext('Wystąpił błąd podczas drukowania etykiety.'),
                );
            }
            return;
        }
        postPrompt({
            options: {
                title: gettext('Duplikacja ID'),
                text: gettext(
                    'Czy na pewno chcesz wydrukować duplikat etykiety?',
                ),
            },
            url: printUrl,
            data: {
                barcode_value: barcodeValue,
            },
            successAction: async (response) => {
                const data = await response.json();
                addAlert('success', data.message);
            },
            failedAction: async (response) => {
                const data = await response.json();
                addAlert(
                    'error',
                    data.message ||
                        gettext('Wystąpił błąd podczas drukowania etykiety.'),
                );
            },
        });
    }
}
